import React from "react";
import { Icon } from "antd";

const ycombinatorSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="currentColor"
  >
    <path d="M43.87,3.507C43.692,3.194,43.36,3,43,3h-6.985c-0.351,0-0.677,0.184-0.858,0.486L24.5,21.265L13.842,3.486 C13.662,3.184,13.336,3,12.985,3H6C5.64,3,5.308,3.194,5.13,3.507C4.952,3.82,4.957,4.205,5.143,4.514L20,29.316V46 c0,0.552,0.448,1,1,1h7c0.552,0,1-0.448,1-1V29.316L43.857,4.514C44.043,4.205,44.048,3.82,43.87,3.507z" />
  </svg>
);

const facebookSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 50 50"
    version="1.1"
    fill="currentColor"
  >
    <g id="surface1043547">
      <path d="M 32 11 L 37 11 C 37.550781 11 38 10.550781 38 10 L 38 3.261719 C 38 2.738281 37.597656 2.304688 37.074219 2.265625 C 35.484375 2.152344 32.375 2 30.140625 2 C 24 2 20 5.679688 20 12.367188 L 20 19 L 13 19 C 12.449219 19 12 19.449219 12 20 L 12 27 C 12 27.550781 12.449219 28 13 28 L 20 28 L 20 47 C 20 47.550781 20.449219 48 21 48 L 28 48 C 28.550781 48 29 47.550781 29 47 L 29 28 L 36.222656 28 C 36.730469 28 37.160156 27.617188 37.214844 27.109375 L 37.992188 20.109375 C 38.058594 19.519531 37.597656 19 37 19 L 29 19 L 29 14 C 29 12.34375 30.34375 11 32 11 Z M 32 11 " />
    </g>
  </svg>
);

const redditSVG = () => (
  <svg
    id="Bold"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="m21.325 9.308c-.758 0-1.425.319-1.916.816-1.805-1.268-4.239-2.084-6.936-2.171l1.401-6.406 4.461 1.016c0 1.108.89 2.013 1.982 2.013 1.113 0 2.008-.929 2.008-2.038s-.889-2.038-2.007-2.038c-.779 0-1.451.477-1.786 1.129l-4.927-1.108c-.248-.067-.491.113-.557.365l-1.538 7.062c-2.676.113-5.084.928-6.895 2.197-.491-.518-1.184-.837-1.942-.837-2.812 0-3.733 3.829-1.158 5.138-.091.405-.132.837-.132 1.268 0 4.301 4.775 7.786 10.638 7.786 5.888 0 10.663-3.485 10.663-7.786 0-.431-.045-.883-.156-1.289 2.523-1.314 1.594-5.115-1.203-5.117zm-15.724 5.41c0-1.129.89-2.038 2.008-2.038 1.092 0 1.983.903 1.983 2.038 0 1.109-.89 2.013-1.983 2.013-1.113.005-2.008-.904-2.008-2.013zm10.839 4.798c-1.841 1.868-7.036 1.868-8.878 0-.203-.18-.203-.498 0-.703.177-.18.491-.18.668 0 1.406 1.463 6.07 1.488 7.537 0 .177-.18.491-.18.668 0 .207.206.207.524.005.703zm-.041-2.781c-1.092 0-1.982-.903-1.982-2.011 0-1.129.89-2.038 1.982-2.038 1.113 0 2.008.903 2.008 2.038-.005 1.103-.895 2.011-2.008 2.011z" />
  </svg>
);

export const YCombinatorIcon = props => (
  <Icon component={ycombinatorSVG} {...props} />
);

export const FacebookIcon = props => (
  <Icon component={facebookSVG} {...props} />
);

export const RedditIcon = props => <Icon component={redditSVG} {...props} />;
